import React, { FC } from 'react'

export const Cursor: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.967 7.242a.633.633 0 0 0-.633.633v9.542c0 .35.283.633.633.633.158 0 .292-.05.4-.133l1.592-1.292 1.383 3.017a.634.634 0 0 0 .575.358c.092 0 .183 0 .275-.067l2.3-1.066c.317-.15.467-.534.3-.842L14.4 15l2.009-.375a.733.733 0 0 0 .358-.217c.225-.266.192-.658-.1-.9L9.384 7.383l-.009.009a.63.63 0 0 0-.408-.15ZM12.5 8.333V6.667h4.167v1.666H12.5Zm-.975-4.366 2.359-2.359 1.175 1.175L12.7 5.142l-1.175-1.175ZM8.334 0H10v4.167H8.334V0ZM3.275 12.217l2.359-2.359 1.175 1.175-2.359 2.359-1.175-1.175Zm0-9.434L4.45 1.608 6.81 3.967 5.634 5.142 3.275 2.783Zm2.559 5.55H1.667V6.667h4.167v1.666Z"
      fill="#000"
    />
  </svg>
)
